import AGREEMENT from '../agreement';
import LANGUAGES from '../languages';

export default {
	APP_TITLE: 'HollaEx',
	APP_SUB_TITLE: 'Open Crypto Exchange', // slogan

	LOGOUT_CONFIRM_TEXT: '本当にログアウトしますか？',
	ADD_TRADING_PAIR: '通貨ペア追加',
	ACTIVE_TRADES: '仮想通貨の取引を利用するためには、{0}を完了してください。',
	CANCEL_BASE_WITHDRAWAL: '{0}出金キャンセル',
	CANCEL_WITHDRAWAL: '出金キャンセル',
	CANCEL_WITHDRAWAL_POPUP_CONFIRM: '保留中の出金をキャンセルしますか？',
	CANT_BE_CANCELLED: '-',
	ALREADY_CANCELLED: '-',
	TIMESTAMP_FORMAT: 'YYYY/MM/DD HH:mm:ss',
	HOUR_FORMAT: 'HH:mm:ss',
	LOGIN_TEXT: 'ログイン',
	SIGN_IN: 'ログイン',
	SIGNUP_TEXT: '会員登録',
	REGISTER_TEXT: '新規登録',
	ACCOUNT_TEXT: 'アカウント',
	HOME_TEXT: 'ホーム',
	CLOSE_TEXT: '閉じる',
	COPY_TEXT: 'コピー',
	COPY_SUCCESS_TEXT: 'コピーされました',
	CANCEL_SUCCESS_TEXT: '正常にキャンセルされました！',
	UPLOAD_TEXT: 'アップロード',
	ADD_FILES: 'ファイルを追加', // ToDo
	OR_TEXT: 'または',
	CONTACT_US_TEXT: 'お問い合わせ',
	HELPFUL_RESOURCES_TEXT: 'ヘルプ',
	HELP_RESOURCE_GUIDE_TEXT:
		'お問い合わせはサポートセンターまでご連絡ください。',
	HELP_RESOURCE_GUIDE: {
		CONTACT_US: 'お問い合わせ',
		TEXT: '詳細や問題については、メールでお気軽に {0} ください。',
	},
	HELP_TELEGRAM_TEXT: 'オープンAPIドキュメント：',
	HELP_TELEGRAM_LINK: 'https://apidocs.HollaEx.com',
	NEED_HELP_TEXT: 'ヘルプが必要ですか？', // new
	HELP_TEXT: 'ヘルプ',
	SUCCESS_TEXT: '成功',
	ERROR_TEXT: 'エラー',
	PROCEED: '続行',
	EDIT_TEXT: '編集',
	BACK_TEXT: '戻る',
	NO_OPTIONS: '利用できるオプションがありません。',
	SECONDS: '秒',
	VIEW_MARKET: 'マーケットを見る', // new
	GO_TRADE: '取引を始める', // new
	VIEW_INFO: 'インフォメーション', // new
	APPLY_HERE: 'Apply Here', // new
	HOME: {
		SECTION_1_TITLE: 'HollaEx Exchange Kitへようこそ！',
		SECTION_1_TEXT_1:
			'Build your own scalable digital asset exchange with HollaEx Kit and be part of the future of finance.',
		SECTION_1_TEXT_2:
			'We strive to bring the financial technology forward through affordable and simple access to trading technology.',
		SECTION_1_BUTTON_1: 'Learn more',
		SECTION_3_TITLE: 'Features',
		SECTION_3_CARD_1_TITLE: 'SCALABLE MATCHING ENGINE',
		SECTION_3_CARD_1_TEXT:
			'High performance and scalable order matching engine using the most efficient algorithms',
		SECTION_3_CARD_2_TITLE: 'BANK INTEGRATION',
		SECTION_3_CARD_2_TEXT:
			'Plugins with customizable modules available for bank integration. We know the traditional finance and can help you to make your exchange local',
		SECTION_3_CARD_3_TITLE: 'STRONG SECURITY',
		SECTION_3_CARD_3_TEXT:
			'HollaEx uses the best security practices and the most secure and reliable algorithms for keeping the funds secure. It is our top priority and we took a very special extra care of it.',
		SECTION_3_CARD_4_TITLE: 'ADVANCED REPORTING',
		SECTION_3_CARD_4_TEXT:
			'Admin panel with customizable email and reports for notifying support and administrator about the status of the system and transactions.',
		SECTION_3_CARD_5_TITLE: 'SUPPORT',
		SECTION_3_CARD_5_TEXT:
			'We can take an extra care for your needs and have an online professional to help with your issues and inquiries.',
		SECTION_3_CARD_6_TITLE: 'KYC INTEGRATION',
		SECTION_3_CARD_6_TEXT:
			'Flexible and integrable modules to apply KYC and user verification methods in different jurisdiction.',
		SECTION_3_BUTTON_1: 'View Demo',
	},
	FOOTER: {
		FOOTER_LEGAL: ['Proudly made in Seoul, South Korea', 'bitHolla Inc.'],
		FOOTER_LANGUAGE_TEXT: 'LANGUAGE',
		SECTIONS: {
			SECTION_1_TITLE: 'ABOUT',
			SECTION_1_LINK_1: 'About Us',
			SECTION_1_LINK_2: '利用規約',
			SECTION_1_LINK_3: 'プライバシーポリシー',
			SECTION_1_LINK_4: 'Contact Us',
			SECTION_2_TITLE: 'INFORMATION',
			SECTION_2_LINK_1: 'ブログ',
			SECTION_2_LINK_2: 'お問い合わせ',
			SECTION_2_LINK_3: '採用情報',
			SECTION_3_TITLE: 'DEVELOPERS',
			SECTION_3_LINK_1: 'Documentation',
			SECTION_3_LINK_2: 'Forum',
			SECTION_3_LINK_3: 'GitHub',
			SECTION_3_LINK_4: 'ライブラリ',
			SECTION_3_LINK_5: 'APIドキュメント',
			SECTION_3_LINK_6: 'Trading API',
			SECTION_3_LINK_7: 'Developer tools',
			SECTION_3_LINK_8: 'Documnetation',
			SECTION_4_TITLE: 'EXCHANGE',
			SECTION_4_LINK_1: 'ログイン',
			SECTION_4_LINK_2: '新規登録',
			SECTION_4_LINK_3: 'お問い合わせ',
			SECTION_4_LINK_4: '利用規約',
			SECTION_5_TITLE: 'RESOURCES',
			SECTION_5_LINK_1: 'ホワイトペーパー',
			SECTION_5_LINK_2: 'HollaEx Token (XHT) ',
			SECTION_5_LINK_3: 'GitHub',
			SECTION_5_LINK_4: 'FAQ', // new
			SECTION_6_TITLE: 'SOCIAL',
			SECTION_6_LINK_1: 'Twitter',
			SECTION_6_LINK_2: 'Telegram',
			SECTION_6_LINK_3: 'Facebook', // new
			SECTION_6_LINK_4: 'Instagram', // new
			SECTION_6_LINK_5: 'Linkedin', // new
			SECTION_6_LINK_6: 'Website', // new
			SECTION_6_LINK_7: 'ヘルプデスク', // new
			SECTION_6_LINK_8: 'インフォメーション', // new
			SECTION_6_LINK_9: 'YouTube', // new
		},
		XHT_DESCRIPTION:
			'HollaEx Kit is an open source trading platform built by bitHolla Inc. You can create and list any digital assets and onboard users to trade on your exchange using this exchange Kit. In order to simply run one yourself {1}.',
		CLICK_HERE: 'click here',
		VISIT_HERE: 'visit here',
	},
	ACCOUNTS: {
		TITLE: 'マイページ',
		TAB_VERIFICATION: '会員情報',
		TAB_SECURITY: 'セキュリティ',
		TAB_NOTIFICATIONS: 'アラート',
		TAB_SETTINGS: '設定',
		TAB_PROFILE: 'プロファイル',
		TAB_WALLET: 'ウォレット',
		TAB_SUMMARY: 'マイページ',
		TAB_HISTORY: '履歴',
		TAB_API: 'API',
		TAB_SIGNOUT: 'ログアウト',
	},
	REQUEST_XHT_ACCESS: {
		// new
		REQUEST_TITLE: '接続リンクリクエスト',
		REQUEST_INVITE: '招待リクエスト',
		CATEGORY_PLACEHOLDER: 'お客様に当てはまるカテゴリーを選択してください。',
		INTRODUCTION_LABEL: '自己紹介',
		INTRODUCTION_PLACEHOLDER:
			'ベースはどこですか？取引所の運営に興味がありますか？',
	},
	CONTACT_FORM: {
		CATEGORY_LABEL: 'お問い合わせの種類',
		CATEGORY_PLACEHOLDER: 'お問い合わせの種類を選択してください。',
		CATEGORY_OPTIONS: {
			OPTION_VERIFY: '本人確認関連',
			OPTION_LEVEL: 'アカウントレベルのアップグレード',
			OPTION_DEPOSIT: '入金・出金',
			OPTION_BUG: 'エラー報告', // ToDo:
			OPTION_PERSONAL_INFO: '個人情報の変更', // ToDo:
			OPTION_BANK_TRANSFER: '銀行送金', // new
			OPTION_REQUEST: 'HollaEx招待リクエスト', // new
		},
		SUBJECT_LABEL: '件名',
		SUBJECT_PLACEHOLDER: 'お問い合わせの件名を入力してください。',
		DESCRIPTION_LABEL: 'お問い合わせ内容',
		DESCRIPTION_PLACEHOLDER: 'お問い合わせ内容の詳細を記載してください。',
		ATTACHMENT_LABEL: 'ファイル添付(最大3つ)', // ToDo:
		ATTACHMENT_PLACEHOLDER:
			'より正確な問題解決のため、お問い合わせ内容に関したイメージファイルを添付してください。(PDF, JPG, PNG, GIF ファイル添付可能)',
		SUCCESS_MESSAGE: 'サポートセンターにお問い合わせが受付されました。',
		SUCCESS_TITLE: '受付完了',
		SUCCESS_MESSAGE_1:
			'お客様のお問い合わせがサポートセンターに受付されました。',
		SUCCESS_MESSAGE_2: '営業日基準1～3日が掛かります。',
	},
	DEPOSIT: {
		CRYPTO_LABELS: {
			ADDRESS: '{0}入金アドレス', // new
			DESTINATION_TAG: '{0}デスティネーションタグ', // new
			MEMO: 'Your{0}memo', // new
			BTC: 'ビットコイン入金アドレス',
			ETH: 'イーサリアム入金アドレス',
			BCH: 'ビットコインキャッシュ入金アドレス',
		},
		INCREASE_LIMIT: '限度額の増加が必要ですか？',
		QR_CODE:
			'このQRコードをスキャンして、お客様専用の入金アドレスへ入金できます。',
		NO_DATA: '利用可能な情報がありません。',
		FULL_MESSAGE_LIMIT: '{0}: {1} {2} {3}', //  0 -> {Daily deposit max amount}:  1 -> {50,000,000} 2 -> {T} 3 -> {(Want to increase your daily limit?)}
	},
	LOGIN: {
		LOGIN_TO: '{0}にログイン',
		CANT_LOGIN: 'ログインにお困りですか？',
		NO_ACCOUNT: 'アカウントをお持ちでないですか？',
		CREATE_ACCOUNT: 'アカウント作成',
		HELP: 'ヘルプ',
	},
	FORM_FIELDS: {
		EMAIL_LABEL: 'メール',
		EMAIL_PLACEHOLDER: 'メールアドレスを入力',
		PASSWORD_LABEL: 'パスワード',
		PASSWORD_PLACEHOLDER: 'パスワードを入力',
		PASSWORD_REPEAT_LABEL: 'パスワードの確認',
		PASSWORD_REPEAT_PLACEHOLDER: 'パスワードをもう一度入力',
	},
	VALIDATIONS: {
		OTP_LOGIN: 'ログインのためOTPコードを入力してください。',
		CAPTCHA: 'Expired Session. Please refresh the page',
		FROZEN_ACCOUNT: 'This account is frozen',
		INVALID_EMAIL: '無効なメールアドレスです。',
		TYPE_EMAIL: 'メールアドレスを入力してください。',
		REQUIRED: '必須入力',
		INVALID_DATE: '間違った日付',
		INVALID_PASSWORD:
			'ご利用できないパスワードです。(パスワードは8文字以上で、数字、記号を含む必要があります)',
		INVALID_PASSWORD_2:
			'ご利用できないパスワードです。(パスワードは8文字以上で、数字、記号を最低1文字ずつ含む必要があります)',
		INVALID_CURRENCY: '間違った{0}アドレス({1})',
		INVALID_BALANCE:
			'({1})を実行するために必要な({0})の使用可能残高が足りません。',
		MIN_VALUE: '値は必ず{0}または、これより高い必要があります。',
		MAX_VALUE: '値は必ず{0}または、これより低い必要があります。',
		INSUFFICIENT_BALANCE: '残高が足りません',
		PASSWORDS_DONT_MATCH: 'パスワードが間違っています。',
		USER_EXIST: '既に登録されたメールアドレスです。',
		ACCEPT_TERMS: '利用規約およびプライバシーポリシーに同意してください。',
		STEP: '間違った値, step is {0}',
		ONLY_NUMBERS: '数字のみ入力可能です。',
	},
	LEGAL: {
		PRIVACY_POLICY: {
			TITLE: 'Privacy Policy',
			SUBTITLE:
				'Last updated April 1, 2019. Replaces the prior version in its entirety.',
			TEXTS: [
				'HollaEx Web is a virtual trading platform that is wholly owned by bitHolla Inc. bitHolla Inc (hereinafter referred to as bitHolla) was incorporated in Seoul South Korea.',
				'Use of this HollaEx website (“Website”) and the service offered on the Website (“Service”) are governed by the terms contained on this Terms and Conditions page (“Terms”). This agreement entirely constitutes the agreement between the parties. All other information provided on the Website or oral/written statements made are excluded from this agreement; the exchange policy is provided for guidance only and does not constitute a legal agreement between the parties.',
				'By accessing, viewing or downloading information from the Website and using the Service provided by bitHolla you acknowledge that you have read, understand, and unconditionally agree to be bound by these Terms. bitHolla may at any time, without notice, amend the Terms. You agree to continue to be bound by any amended terms and conditions and that bitHolla has no obligation to notify you of such amendments. You acknowledge that it is your responsibility to check these Terms periodically for changes and that your continued use of the Website and Services offered by bitHolla following the posting of any changes to the Terms indicates your acceptance of any such changes.',
				'The Website and the copyright in all text, graphics, images, software and any other materials on the Website is owned by bitHolla including all trademarks and other intellectual property rights in respect of materials and Service on the Website. Materials on this Website may only be used for personal use and non-commercial purposes.',
				'You may display on a computer screen or print extracts from the Website for the above-stated purpose only provided that you retain any copyright and other proprietary notices or any bitHolla trademarks or logos, as shown on the initial printout or download without alteration, addition or deletion. Except as expressly stated herein, you may not without bitHolla’s prior written permission alter, modify, reproduce, distribute or use in any other commercial context any materials from the Website.',
				'You acknowledge that ‘bitHolla’ and the bitHolla logo are trademarks of bitHolla Inc. You may reproduce such trademarks without alteration on material downloaded from this Website to the extent authorised above, but you may not otherwise use, copy, adapt or erase them.',
				'You shall not in any circumstances obtain any rights over or in respect of the Website (other than rights to use the Website pursuant to these Terms and any other terms and conditions governing a particular service or section of the Website) or hold yourself out as having any such rights over or in respect of the Website.',
			],
		},
		GENERAL_TERMS: {
			TITLE: 'General Terms of Service',
			SUBTITLE:
				'Last updated April 1, 2019. Replaces the prior version in its entirety.',
			TEXTS: [
				'HollaEx Web is a virtual trading platform that is wholly owned by bitHolla Inc. bitHolla Inc (hereinafter referred to as bitHolla) was incorporated in Seoul South Korea.',
				'Use of this HollaEx website (“Website”) and the service offered on the Website (“Service”) are governed by the terms contained on this Terms and Conditions page (“Terms”). This agreement entirely constitutes the agreement between the parties. All other information provided on the Website or oral/written statements made are excluded from this agreement; the exchange policy is provided for guidance only and does not constitute a legal agreement between the parties.',
				'By accessing, viewing or downloading information from the Website and using the Service provided by bitHolla you acknowledge that you have read, understand, and unconditionally agree to be bound by these Terms. bitHolla may at any time, without notice, amend the Terms. You agree to continue to be bound by any amended terms and conditions and that bitHolla has no obligation to notify you of such amendments. You acknowledge that it is your responsibility to check these Terms periodically for changes and that your continued use of the Website and Services offered by bitHolla following the posting of any changes to the Terms indicates your acceptance of any such changes.',
				'The Website and the copyright in all text, graphics, images, software and any other materials on the Website is owned by bitHolla including all trademarks and other intellectual property rights in respect of materials and Service on the Website. Materials on this Website may only be used for personal use and non-commercial purposes.',
				'You may display on a computer screen or print extracts from the Website for the above-stated purpose only provided that you retain any copyright and other proprietary notices or any bitHolla trademarks or logos, as shown on the initial printout or download without alteration, addition or deletion. Except as expressly stated herein, you may not without bitHolla’s prior written permission alter, modify, reproduce, distribute or use in any other commercial context any materials from the Website.',
				'You acknowledge that ‘bitHolla’ and the bitHolla logo are trademarks of bitHolla Inc. You may reproduce such trademarks without alteration on material downloaded from this Website to the extent authorised above, but you may not otherwise use, copy, adapt or erase them.',
				'You shall not in any circumstances obtain any rights over or in respect of the Website (other than rights to use the Website pursuant to these Terms and any other terms and conditions governing a particular service or section of the Website) or hold yourself out as having any such rights over or in respect of the Website.',
			],
		},
	},
	NOTIFICATIONS: {
		BUTTONS: {
			OKAY: 'Okay',
			START_TRADING: '取引を始める',
			SEE_HISTORY: '取引履歴を見る',
		},
		DEPOSITS: {
			TITLE_RECEIVED: '{0}入金完了',
			TITLE_INCOMING: '{0}入金中',
			SUBTITLE_RECEIVED: '{0}入金が完了しました。',
			SUBTITLE_INCOMING: '{0}入金中です。',
			INFORMATION_PENDING_1:
				'取引を始めるためには{0}には少なくとも１つ以上の確認が必要です。',
			INFORMATION_PENDING_2:
				'通常の入金完了には10～30分が所要されますが、状況によってはもっと時間が掛かる場合もあります。{0}がブロックチェーン上で完了され次第メールをお送りいたします。',
		},
	},
	REFERRAL_SUCCESS: {
		TITLE: 'リクエストを送りました。',
		BUTTON_TEXT: 'Okay',
	},
	OTP_FORM: {
		OTP_FORM_TITLE: '認証番号を入力し、手続きを続行してください。',
		OTP_LABEL: 'OTPコード',
		OTP_PLACEHOLDER: '認証番号を入力する',
		OTP_TITLE: '認証番号',
		OTP_HELP: 'ヘルプ',
		OTP_BUTTON: '確認',
		ERROR_INVALID: '無効なOTPコードです。',
	},
	QUICK_TRADE_COMPONENT: {
		TITLE: 'クイック取引',
		TOTAL_COST: '総額',
		BUTTON: '{0}',
		INPUT: '{0}を{1}',
		TRADE_TITLE: '{0} {1}', // quick buy
	},
	PREVIOUS_PAGE: '前のページ',
	NEXT_PAGE: '次のページ',
	WALLET: {
		LOADING_ASSETS: '資産を読込中...', // new
		TOTAL_ASSETS: '総資産',
		AVAILABLE_WITHDRAWAL: '出金可能な資産',
		AVAILABLE_TRADING: '取引可能な資産',
		ORDERS_PLURAL: '注文',
		ORDERS_SINGULAR: '注文',
		HOLD_ORDERS:
			'You have {0} open {1}, resulting in a hold of {2} {3} placed on your {4} balance',
	},
	REQUEST_RESET_PASSWORD: {
		TITLE: 'パスワードの再設定',
		SUBTITLE: `以下のアカウントのパスワードを再設定できます。`,
		SUPPORT: 'お問い合わせ',
		BUTTON: '再設定リンクを送る',
	},
	REQUEST_RESET_PASSWORD_SUCCESS: {
		TITLE: 'パスワード再設定のメールを送信しました。',
		TEXT:
			'アカウントに登録されたメールアドレスから再設定の手続きが含まれたメールを受け取れます。メールを確認してリンクに接続し、パスワードの再設定を完了してください。',
	},
	RESET_PASSWORD: {
		TITLE: '新しいパスワードの設定',
		SUBTITLE: '新しいパスワードを設定します。',
		BUTTON: '新しいパスワードに設定する',
	},
	RESET_PASSWORD_SUCCESS: {
		TEXT_1: '新しいパスワードが正常に設定されました。',
		TEXT_2: '続けるにはログインボタンを押してください。',
	},
	SIGN_UP: {
		SIGNUP_TO: '{0}に登録する',
		NO_EMAIL: 'メールが届きませんか？',
		REQUEST_EMAIL: 'メールをもう一度要請する',
		HAVE_ACCOUNT: '既にアカウントをお持ちですか？',
		GOTO_LOGIN: 'ログインページに移動する',
		AFFILIATION_CODE: '紹介者コード(選択)',
		AFFILIATION_CODE_PLACEHOLDER: '紹介者コードを入力',
		TERMS: {
			terms: '利用規約',
			policy: 'プライバシーポリシー',
			text: '{0}と{1}を確認し、これに同意します。',
		},
	},
	VERIFICATION_TEXTS: {
		TITLE: '認証メールが送信されました。',
		TEXT_1: '送られたメールにあるリンクで認証手続きを続行してください。',
		TEXT_2:
			'メールが届かない場合、迷惑メールを確認してみてください。または、下からメールを再送信できます。',
	},
	VERIFICATION_EMAIL_REQUEST: {
		TITLE: '認証メールの再送信',
		BUTTON: '認証メールを再送信する',
	},
	VERIFICATION_EMAIL_REQUEST_SUCCESS: {
		TITLE: '認証メールが再送信されました。',
		TEXT_1: '引き続きメールが届かない場合は下からお問い合わせください。',
	},
	VERIFICATION_EMAIL: {
		INVALID_UUID: '無効なコード',
		TEXT_1: 'メールアカウントが正常に認証されました。',
		TEXT_2: 'ログインしてください。',
	},
	USER_VERIFICATION: {
		INFO_TXT: 'ここから個人情報およびアップグレード状況を確認できます。',
		INFO_TXT_1:
			'以下の各部分に必要な情報を記入してください。全部分の提出が完了した後、審査を通してアカウントのアップグレードが承認されます。',
		INFO_TXT_2: '*認証には{0}が必要です。',
		DOCUMENTATIONS: 'アップロード',
		COMPLETED: '完了',
		PENDING_VERIFICATION: '認証中',
		TITLE_EMAIL: 'メール',
		MY_EMAIL: 'マイメール',
		MAKE_FIRST_DEPOSIT: '初めての入金をする', // new
		OBTAIN_XHT: 'XHT受取', // new
		TITLE_USER_DOCUMENTATION: '本人確認',
		TITLE_ID_DOCUMENTS: 'アップロード',
		TITLE_BANK_ACCOUNT: '銀行口座',
		TITLE_MOBILE_PHONE: '携帯電話',
		TITLE_PERSONAL_INFORMATION: '個人情報',
		VERIFY_EMAIL: 'メールアドレスの認証',
		VERIFY_MOBILE_PHONE: '携帯電話の認証',
		VERIFY_USER_DOCUMENTATION: '本人確認書類の認証',
		VERIFY_ID_DOCUMENTS: '身分証明書の認証',
		VERIFY_BANK_ACCOUNT: '銀行口座の認証',
		BUTTON: '認証要請を提出する',
		TITLE_IDENTITY: '個人情報',
		TITLE_MOBILE: '携帯電話',
		TITLE_MOBILE_HEADER: '携帯電話番号',
		TITLE_BANK: '銀行',
		TITLE_BANK_HEADER: '銀行の詳細情報',
		CHANGE_VALUE: '値を変更する',
		PENDING_VERIFICATION_PERSONAL_INFORMATION: '個人情報の認証を処理中です。',
		PENDING_VERIFICATION_BANK: '銀行情報の認証を処理中です。',
		PENDING_VERIFICATION_DOCUMENTS: '書類の認証を処理中です。',
		GOTO_VERIFICATION: '認証ページに移動する',
		GOTO_WALLET: 'ウォレットに移動する', // new
		CONNECT_BANK_ACCOUNT: '銀行口座を連動する',
		ACTIVATE_2FA: '2段階認証を設定する',
		INCOMPLETED: '完了されていません',
		BANK_VERIFICATION: '銀行の認証',
		IDENTITY_VERIFICATION: '個人情報の認証',
		PHONE_VERIFICATION: '携帯電話の認証',
		DOCUMENT_VERIFICATION: '個人情報提出',
		START_BANK_VERIFICATION: '銀行の認証を始める',
		START_IDENTITY_VERIFICATION: '本人確認を始める',
		START_PHONE_VERIFICATION: '携帯電話の認証を始める',
		START_DOCUMENTATION_SUBMISSION: '書類をアップロードする',
		GO_BACK: '戻る',
		BANK_VERIFICATION_TEXT_1:
			'銀行口座は3つまで追加できます。海外の銀行口座の場合は出金限度に制限があります。追加にはサポートセンターにお問い合わせください。',
		BANK_VERIFICATION_TEXT_2:
			'銀行口座を登録すると以下のサービスがご利用できます：',
		BASE_WITHDRAWAL: 'フィアット出金',
		BASE_DEPOSITS: 'フィアット入金',
		ADD_ANOTHER_BANK_ACCOUNT: '他の銀行口座を追加する',
		BANK_NAME: '銀行名',
		ACCOUNT_NUMBER: '口座番号',
		CARD_NUMBER: 'カード番号',
		BANK_VERIFICATION_HELP_TEXT: '{0}を完了した後、認証が続行可能です。',
		DOCUMENT_SUBMISSION: '書類の提出',
		REVIEW_IDENTITY_VERIFICATION: '個人情報の編集',
		PHONE_DETAILS: '連絡先情報',
		PHONE_COUNTRY_ORIGIN: '国家',
		MOBILE_NUMBER: '電話番号',
		DOCUMENT_PROOF_SUBMISSION: '個人情報の認証',
		START_DOCUMENTATION_RESUBMISSION: '書類を再提出する',
		SUBMISSION_PENDING_TXT:
			'*この項目は既に提出されています。再提出すると情報が更新されます。',
		CUSTOMER_SUPPORT_MESSAGE: 'サポートセンターのメッセージ',
		DOCUMENT_PENDING_NOTE:
			'提出した書類が審査中です。完了するまでお待ちください。',
		DOCUMENT_VERIFIED_NOTE: '書類審査が完了しました。',
		NOTE_FROM_VERIFICATION_DEPARTMENT: '審査部署からの通知事項',
		CODE_EXPIRES_IN: 'コード満了まで',
		USER_DOCUMENTATION_FORM: {
			FORM_FIELDS: {
				FIRST_NAME_LABEL: '名',
				FIRST_NAME_PLACEHOLDER: '身分証明書の表記と同じく入力してください。',
				LAST_NAME_LABEL: '姓',
				LAST_NAME_PLACEHOLDER: '身分証明書の表記と同じく入力してください。',
				FULL_NAME_LABEL: 'フルネーム',
				FULL_NAME_PLACEHOLDER: '身分証明書の表記と同じく入力してください。',
				GENDER_LABEL: '性別',
				GENDER_PLACEHOLDER: '性別を選択してください。',
				GENDER_OPTIONS: {
					MAN: '男性',
					WOMAN: '女性',
				},
				NATIONALITY_LABEL: '国籍',
				NATIONALITY_PLACEHOLDER:
					'お客様の身分証明書に表記された国籍を選択してください。',
				DOB_LABEL: '生年月日',
				COUNTRY_LABEL: '現在の居住国家',
				COUNTRY_PLACEHOLDER: '現在居住している国家を選択してください。',
				CITY_LABEL: '都市',
				CITY_PLACEHOLDER: '現在居住している都市を入力してください。',
				ADDRESS_LABEL: '住所',
				ADDRESS_PLACEHOLDER: '住所を入力してください。',
				POSTAL_CODE_LABEL: '郵便番号',
				POSTAL_CODE_PLACEHOLDER: '郵便番号を入力してください。',
				PHONE_CODE_LABEL: '国家',
				PHONE_CODE_PLACEHOLDER:
					'利用している携帯電話が開通されている国家を選択してください。',
				PHONE_CODE_DISPLAY: '({0}) {1}', // 0 -> (+21)  1 -> South Korea
				PHONE_NUMBER_LABEL: '携帯電話番号',
				PHONE_NUMBER_PLACEHOLDER: '電話番号を入力してください。',
				CONNECTING_LOADING: '接続中',
				SMS_SEND: 'SMSを送る',
				SMS_CODE_LABEL: 'SMSコード',
				SMS_CODE_PLACEHOLDER: '受信されたSMSコードを入力してください。',
			},
			INFORMATION: {
				TEXT:
					'重要：お客様の本人確認書類と同じく氏名を入力してください。法人のお客様はお問い合わせください。',
				TITLE_PERSONAL_INFORMATION: '個人情報',
				TITLE_PHONE: '連絡先',
				PHONE_VERIFICATION_TXT:
					'有効な連絡先情報を提供することで、お客様のアカウントで行われる不正な取引を防止し、HollaExが問題を解決するのに役に立ちます。',
				PHONE_VERIFICATION_TXT_1:
					'携帯電話番号を認証することで、お客様の入出金履歴がリアルタイムで提供されます。',
				PHONE_VERIFICATION_TXT_2:
					'選択事項：LAN電話番号を共有して追加認証ができます。',
			},
		},
		ID_DOCUMENTS_FORM: {
			VALIDATIONS: {
				ID_TYPE: '本人確認書類の種類を選択してください。',
				ID_NUMBER: '本人確認書類の番号を入力してください。',
				ISSUED_DATE: '本人確認書類の発行日を選択してください。',
				EXPIRATION_DATE: '本人確認書類の有効期限満了日を入力してください。',
				FRONT: '本人確認書類の表面のコピーを提出してください。',
				PROOF_OF_RESIDENCY: '現在の居住地を証明できる書類を提出してください。',
				SELFIE_PHOTO_ID:
					'本人確認書類の原本とメモを手に持ち、顔と内容が鮮明に見える写真を提出してください。',
			},
			FORM_FIELDS: {
				TYPE_LABEL: '本人確認書類の種類',
				TYPE_PLACEHOLDER: '本人確認書類の種類を選択してください。',
				TYPE_OPTIONS: {
					ID: '身分証明書',
					PASSPORT: 'パスポート',
				},
				ID_NUMBER_LABEL: 'パスポート番号',
				ID_NUMBER_PLACEHOLDER: 'パスポート番号を入力してください。',
				ID_PASSPORT_NUMBER_LABEL: 'パスポート番号',
				ID_PASSPORT_NUMBER_PLACEHOLDER: 'パスポート番号を入力してください。',
				ISSUED_DATE_LABEL: '発行年月日',
				EXPIRATION_DATE_LABEL: '有効期間満了日',
				FRONT_LABEL: '身分証明書の表面',
				FRONT_PLACEHOLDER: '身分証明書の表面のコピーを提出してください。',
				BACK_LABEL: '身分証明書の裏面',
				BACK_PLACEHOLDER: '身分証明書の裏面のコピーを提出してください。',
				PASSPORT_LABEL: 'パスポート',
				PASSPORT_PLACEHOLDER: 'パスポートのコピーを提出してください。',
				POR_LABEL: '居住証明書',
				POR_PLACEHOLDER: '現在の居住地を証明できる書類を提出してください。',
				SELFIE_PHOTO_ID_LABEL: '本人確認書類とメモを持っているお客様の写真',
				SELFIE_PHOTO_ID_PLACEHOLDER:
					'本人確認書類の原本とメモを手に持ち、顔と内容が鮮明に見える写真を提出してください。',
			},
			INFORMATION: {
				IDENTITY_DOCUMENT: 'Identity Document',
				PROOF_OF_RESIDENCY: '居住証明書',
				ID_SECTION: {
					TITLE: '次の事項を確認した上で提出してください。',
					LIST_ITEM_1: '高画質(カラーイメージ、300dpi以上の解像度)のファイル',
					LIST_ITEM_2: '書類全体が鮮明に見えること(ウォーターマーク許可)',
					LIST_ITEM_3: '有効期間内の書類であり、満了日が鮮明に見えること',
					WARNING_1:
						'有効なパスポートのみ許可されます。高画質の写真またはスキャンされたイメージファイルを提出してください。：',
					WARNING_2:
						'提出する書類が本人の物か確認してください。間違った書類や偽造された書類の使用は法的処分およびアカウントが凍結処理されますのでご注意ください。',
					WARNING_3: 'パスポートは居住証明書として提出できません。',
				},
				POR: {
					SECTION_1_TEXT_1: '本人確認手続きを早めるため、次をご確認ください：',
					SECTION_1_TEXT_2:
						'氏名、住所、発行日および発行官庁などの表記が鮮明に見えること',
					SECTION_1_TEXT_3: '居住証明書は発行日より3ヶ月が過ぎていないこと',
					SECTION_1_TEXT_4:
						'提出する書類がカラーおよび高画質であること(最小300dpi)',
					SECTION_2_TITLE: '有効な居住証明書：',
					SECTION_2_LIST_ITEM_1: '銀行口座の取引明細書',
					SECTION_2_LIST_ITEM_2:
						'公共料金請求書(ガス、水道、電気、インターネットなど)',
					SECTION_2_LIST_ITEM_3:
						'政府機関が発行した書類(納税証明書、住民票など)',
					WARNING:
						'身分証明書に表記された住所は居住証明書として使用できません。',
				},
				SELFIE: {
					TITLE: '顔と本人確認書類の撮影',
					INFO_TEXT:
						'以下の規格を確認して、メモとパスポートを手にもった写真を提出してください。顔と本人確認書類の詳細情報が鮮明に見えるように撮影してください。',
					REQUIRED: '必要規格：',
					INSTRUCTION_1: '顔が鮮明に見えること',
					INSTRUCTION_2: 'パスポートの詳細情報が鮮明に見えること',
					INSTRUCTION_3: 'メモの内容：直接書いた取引所名',
					INSTRUCTION_4: 'メモの内容：申請する日付',
					INSTRUCTION_5: 'メモの内容：本人の署名',
					WARNING: '提出した本人確認書類と一致しない場合には拒否されます。',
				},
			},
		},
		BANK_ACCOUNT_FORM: {
			VALIDATIONS: {
				ACCOUNT_OWNER: '銀行口座に登録された氏名を入力してください。',
				ACCOUNT_NUMBER: '銀行の口座番号は50字以内で入力してください。',
				ACCOUNT_NUMBER_MAX_LENGTH: '銀行の口座番号は50字まで入力が可能です。',
				CARD_NUMBER: '入力したカード番号の形式が間違っています。',
			},
			FORM_FIELDS: {
				BANK_NAME_LABEL: '銀行名',
				BANK_NAME_PLACEHOLDER: '銀行名を入力してください。',
				ACCOUNT_NUMBER_LABEL: '口座番号',
				ACCOUNT_NUMBER_PLACEHOLDER: '口座番号を入力してください。',
				ACCOUNT_OWNER_LABEL: '口座の名義',
				ACCOUNT_OWNER_PLACEHOLDER: '口座の名義を入力してください。',
				CARD_NUMBER_LABEL: '銀行のカード番号',
				CARD_NUMBER_PLACEHOLDER: '銀行のカード番号を入力してください。',
			},
		},
		WARNING: {
			TEXT_1: '本人確認を完了すると以下のサービスがご利用できます。',
			LIST_ITEM_1: '出金限度額の増加',
			LIST_ITEM_2: '入金限度額の増加',
			LIST_ITEM_3: '低い手数料',
		},
	},
	USER_SETTINGS: {
		TITLE_TEXT_1: '環境設定ができます。',
		TITLE_TEXT_2: '設定後に保存すると変更内容が適用されます。',
		TITLE_NOTIFICATION: '通知',
		TITLE_INTERFACE: 'インターフェース',
		TITLE_LANGUAGE: '言語',
		TITLE_CHAT: 'チャット',
		TITLE_AUDIO_CUE: 'サウンド', // new
		TITLE_MANAGE_RISK: 'リスク管理',
		ORDERBOOK_LEVEL: 'オーダーブックの表記(最大20)',
		SET_TXT: '設定',
		CREATE_ORDER_WARING: '注文警告の設定',
		RISKY_TRADE_DETECTED: '危ない取引感知',
		RISKY_WARNING_TEXT_1: 'この注文は設定された注文限度額{0}を超えています。',
		RISKY_WARNING_TEXT_2: '(ポートフォリオの{0})',
		RISKY_WARNING_TEXT_3: 'この取引を本当に実行するかもう一度ご確認ください。',
		GO_TO_RISK_MANAGMENT: 'リスク管理に移動',
		CREATE_ORDER_WARING_TEXT:
			'注文値がポートフォリオの{0}を超える場合に警告通知を表示させることができます。',
		ORDER_PORTFOLIO_LABEL: 'ポートフォリオのパーセンテージ：',
		NOTIFICATION_FORM: {
			TRADE_POPUPS: '注文アラート',
			POPUP_ORDER_CONFIRMATION: '注文を入れる前に確認する時',
			POPUP_ORDER_COMPLETED: '注文が完了した時',
			POPUP_ORDER_PARTIALLY_FILLED: '注文が一部成立した時',
		},
		AUDIO_CUE_FORM: {
			// new
			ALL_AUDIO: '全てのサウンド',
			PUBLIC_TRADE_AUDIO: '全ての取引に対して',
			ORDERS_PARTIAL_AUDIO: '注文が一部成立した時',
			ORDERS_PLACED_AUDIO: '注文が入った時',
			ORDERS_CANCELED_AUDIO: '注文がキャンセルされた時',
			ORDERS_COMPLETED_AUDIO: '注文が全て成立した時',
			CLICK_AMOUNTS_AUDIO: '注文一覧の数量と価格をクリックする時',
			GET_QUICK_TRADE_AUDIO: 'クイック取引の注文',
			SUCCESS_QUICK_TRADE_AUDIO: 'クイック取引の注文成立',
			QUICK_TRADE_TIMEOUT_AUDIO: 'クイック取引のタイムアウト',
		},
		RISK_MANAGEMENT: {
			INFO_TEXT:
				'取引注文の値がポートフォリオの設定されたパーセンテージを超えたときに警告が通知されます。',
			INFO_TEXT_1: '総資産価値 {0}：{1}',
			PORTFOLIO: 'ポートフォリオのパーセンテージ',
			VALUE_ASSET: '概算価額',
			ADJUST: '(パーセンテージの設定)',
			ACTIVATE_RISK_MANAGMENT: 'リスク管理の実行',
			WARNING_POP_UP: '警告メッセージ',
		},
	},
	TRANSACTION_HISTORY: {
		TITLE: '履歴',
		TITLE_TRADES: '取引履歴',
		TITLE_DEPOSITS: '入金履歴',
		TITLE_WITHDRAWALS: '出金履歴',
		TEXT_DOWNLOAD: '履歴をダウンロード',
		TRADES: '取引',
		DEPOSITS: '入金',
		WITHDRAWALS: '出金',
	},
	ACCOUNT_SECURITY: {
		TITLE_TEXT:
			'2段階認証、パスワード、APIキー、その他のセキュリティ関連機能でアカウントのセキュリティ設定を調整できます。',
		OTP: {
			TITLE: '2段階認証(2FA)',
			OTP_ENABLED: '2段階認証設定',
			OTP_DISABLED: '2段階認証を設定する',
			ENABLED_TEXTS: {
				TEXT_1: 'ログインする時にOTPコードが必要になります。',
				TEXT_2: '出金をする時にOTPコードが必要になります。',
			},
			DIALOG: {
				SUCCESS: '2段階認証が正常に設定されました。',
				REVOKE: '2段階認証が正常に解除されました。',
			},
			CONTENT: {
				TITLE: '2段階認証の設定',
				MESSAGE_1: 'スキャン',
				MESSAGE_2:
					'下のQRコードを2段階認証アプリのGoogle AuthenticatorまたはAuthyでスキャンして、2段階認証を設定してください。',
				MESSAGE_3:
					'もし、スキャンができない場合は下のコードを手動で入力してください。',
				MESSAGE_4:
					'この2段階認証コードを安全に保存して、携帯電話を変更または、紛失した場合に復元することができます。',
				MESSAGE_5: '手動で入力',
				INPUT: 'OTPコードを入力してください。',
				WARNING:
					'アカウントのセキュリティをより強化するため、認証アプリによる2段階認証(2FA)の設定を強く推奨いたします。',
				ENABLE: '2段階認証を設定する',
				DISABLE: '2段階認証を解除する',
				SECRET_1: 'Enter yor secret key',
				SECRET_2: 'Please enter your secret key to confirm you wrote it down.',
				SECRET_3:
					'This secret key will help you recover your account if you lost access to your phone.',
				INPUT_1: 'Secret Key',

				TITLE_2: 'OTP(One-Time Password)コード入力',
				MESSAGE_6: '下に6桁のOTPコードを入力してください。',
				INPUT_2: 'OTPコード',
			},
			FORM: {
				PLACEHOLDER:
					'Google Authenticatorから発行されたOTPコードを入力してください。',
				BUTTON: '2段階認証を設定する',
			},
		},
		CHANGE_PASSWORD: {
			TITLE: 'パスワードの変更',
			ACTIVE: '設定',
			DIALOG: {
				SUCCESS: 'パスワードが正常に変更されました。',
				EMAIL_CONFIRMATION:
					'パスワードの変更を承認するためのメールが送信されます',
			},
			FORM: {
				BUTTON: 'パスワードを変更する',
				CURRENT_PASSWORD: {
					label: '現在のパスワード',
					placeholder: '使用中のパスワードを入力してください。',
				},
				NEW_PASSWORD: {
					label: '新しいパスワード',
					placeholder: '新しいパスワードを入力してください。',
				},
				NEW_PASSWORD_REPEAT: {
					label: '新しいパスワード確認',
					placeholder: '新しいパスワードをもう一度入力してください。',
				},
			},
		},
		LOGIN: {
			TITLE: 'Login History',
			CONTENT: {
				TITLE: 'Logins History',
				MESSAGE:
					'Below is login history list with details IP, country and time details. If you see any suspicious activity you should change your password and contact support',
			},
		},
		FREEZE: {
			TITLE: 'Freeze Account',
			CONTENT: {
				MESSAGE_1:
					'Freezing your account will stop whitdrawals and halts all tradings.',
				WARNING_1:
					'Use only if you fear that your account has been compromised',
				TITLE_1: 'Freeze your Account',
				TITLE_2: 'Account freezing',
				MESSAGE_2:
					'Freezing your account may help guard your account from cyber attacks.',
				MESSAGE_3:
					'The following will occur if you choose to freeze your account:',
				MESSAGE_4: '1. Pending withdrawals will be canceled.',
				MESSAGE_5:
					'2. All tradings will be halted and unfilled orders will be canceled.',
				MESSAGE_6:
					'3. Containing support will be required to reactivate your account.',
				WARNING_2: 'Do you really want to freeze your account?',
			},
		},
	},
	CURRENCY: '通貨',
	TYPE: 'Type',
	TYPES_VALUES: {
		market: 'market',
		limit: 'limit',
	},
	TYPES: [
		{ value: 'market', label: '成行' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: 'limit', label: '指値' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SIDE: 'Side',
	SIDES_VALUES: {
		buy: '買う',
		sell: '売る',
	},
	SIDES: [
		{ value: 'buy', label: '買う' },
		{ value: 'sell', label: '売る' },
	], // DO NOT CHANGE value, ONLY TRANSLATE label
	DEFAULT_TOGGLE_OPTIONS: [
		{ value: true, label: 'オン' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: false, label: 'オフ' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SIZE: ' 数量',
	PRICE: '価格',
	FEE: 'Fee',
	FEES: '手数料',
	LIMIT: 'Limit',
	TIME: '時間',
	TIMESTAMP: 'Timestamp',
	MORE: 'More',
	VIEW: 'View',
	STATUS: 'ステータス',
	AMOUNT: '数量',
	COMPLETE: 'Complete',
	PENDING: 'Pending',
	REJECTED: 'Rejected',
	ORDERBOOK: '注文一覧',
	CANCEL: 'Cancel',
	CANCEL_ALL: 'Cancel All',
	GO_TRADE_HISTORY: '取引履歴を見る',
	ORDER_ENTRY: '注文',
	TRADE_HISTORY: '取引履歴',
	CHART: ' 価格チャート',
	ORDERS: '注文',
	TRADES: '取引履歴',
	RECENT_TRADES: '最近の取引履歴', // ToDo
	PUBLIC_SALES: '全取引履歴', // ToDo
	REMAINING: 'Remaining',
	FULLFILLED: '{0} % Filled',
	FILLED: 'Filled', // new
	LOWEST_PRICE: 'Lowest Price ({0})', // new
	PHASE: 'Phase', // new
	INCOMING: 'Incoming', // new
	PRICE_CURRENCY: '価格',
	AMOUNT_SYMBOL: '数量',
	MARKET_PRICE: '市場価格',
	ORDER_PRICE: '注文価格',
	TOTAL_ORDER: '総額',
	NO_DATA: 'データがありません。',
	LOADING: 'Loading',
	CHART_TEXTS: {
		d: 'Date',
		o: 'Open',
		h: 'High',
		l: 'Low',
		c: 'Close',
		v: '取引量',
	},
	QUICK_TRADE: 'クイック取引',
	PRO_TRADE: 'プロ向け取引',
	ADMIN_DASH: '管理ページ',
	WALLET_TITLE: 'ウォレット',
	TRADING_MODE_TITLE: '取引モード',
	TRADING_TITLE: '取引',
	LOGOUT: 'ログアウト',
	WITHDRAWALS_MIN_VALUE_ERROR:
		'入力した金額が最低金額より低いため出金できません。金額を変更後、もう一度お試しください。',
	WITHDRAWALS_MAX_VALUE_ERROR:
		'入力した金額が最大金額より高いため出金できません。金額を変更後、もう一度お試しください。',
	WITHDRAWALS_LOWER_BALANCE:
		'You don’t have enough {0} in your balance to send that transaction',
	WITHDRAWALS_FEE_TOO_LARGE:
		'The fee is more than {0}% of your total transaction',
	WITHDRAWALS_BTC_INVALID_ADDRESS:
		'無効なビットコインアドレスです。確認後、もう一度お試しください。',
	WITHDRAWALS_ETH_INVALID_ADDRESS:
		'無効なイーサリアムアドレスです。確認後、もう一度お試しください。',
	WITHDRAWALS_BUTTON_TEXT: '出金内容を確認',
	WITHDRAWALS_FORM_ADDRESS_LABEL: '送金先',
	WITHDRAWALS_FORM_ADDRESS_PLACEHOLDER: '出金先のアドレスを入力',
	WITHDRAWALS_FORM_DESTINATION_TAG_LABEL: 'Destination tag (optional)', // new
	WITHDRAWALS_FORM_MEMO_LABEL: 'Memo (optional)', // new
	WITHDRAWALS_FORM_DESTINATION_TAG_PLACEHOLDER: 'Type the destination tag', // new
	WITHDRAWALS_FORM_MEMO_PLACEHOLDER: 'Type the transaction memo', // new
	WITHDRAWALS_FORM_AMOUNT_LABEL: '送金する {0} 金額',
	WITHDRAWALS_FORM_AMOUNT_PLACEHOLDER:
		'Type the amount of {0} you wish to withdraw',
	WITHDRAWALS_FORM_FEE_COMMON_LABEL: '取引手数料',
	WITHDRAWALS_FORM_FEE_FIAT_LABEL: 'Bank withdrawal fee',
	WITHDRAWALS_FORM_FEE_PLACEHOLDER:
		'Type the amount of {0} you wish to use in the fee of the transaction',
	WITHDRAWALS_FORM_FEE_OPTIMAL_VALUE: 'Optimal fee: {0} {1}', // TODO {0} -> amount {1} -> currency name
	DEPOSITS_FORM_AMOUNT_LABEL: '{0} amount to deposit',
	DEPOSITS_FORM_AMOUNT_PLACEHOLDER:
		'Type the amount of {0} you wish to withdraw',
	DEPOSITS_BUTTON_TEXT: 'review deposit',
	DEPOSIT_PROCEED_PAYMENT: 'Pay',
	DEPOSIT_BANK_REFERENCE:
		'Add this "{0}" code to the bank transation to identify the deposit',
	DEPOSIT_METHOD: 'お支払い方法 {0}',
	DEPOSIT_METHOD_DIRECT_PAYMENT: 'クレジットカード',
	DEPOSIT_METHOD_DIRECT_PAYMENT_MESSAGE_1:
		'クレジットカードでのお支払い手続きに進みます。',
	DEPOSIT_METHOD_DIRECT_PAYMENT_MESSAGE_2:
		'お支払いを続行するためページを離れます。',
	DEPOSIT_VERIFICATION_WAITING_TITLE: '決済確認中',
	DEPOSIT_VERIFICATION_WAITING_MESSAGE:
		'決済が完了するまでこの画面を閉じないでください。',
	DEPOSIT_VERIFICATION_WARNING_MESSAGE:
		'決済中に問題が発生した場合は、サポートセンターまでお問い合わせください。',
	DEPOSIT_VERIFICATION_WARNING_INFORMATION:
		'This is the ID of the operation: "{0}", please provide us this ID to help you.',
	DEPOSIT_VERIFICATION_SUCCESS: '決済完了',
	DEPOSIT_VERIFICATION_ERROR: '入金中に問題が発生しました。',
	DEPOSIT_VERIFICATION_ERROR_VERIFIED: 'この入金は既に確認されています。',
	DEPOSIT_VERIFICATION_ERROR_STATUS: '入金エラー',
	DEPOSIT_VERIFICATION_ERROR_USER_MATCH:
		'入金にご利用されたカードはアカウントに登録されているカードと異なります。お客様の入金は拒否され、1時間以内に返金されます。',
	QUOTE_MESSAGE: 'You are going to {0} {1} {2} for {3} {4}',
	QUOTE_BUTTON: 'Accept',
	QUOTE_REVIEW: 'Review',
	QUOTE_COUNTDOWN_MESSAGE: 'You have {0} seconds to perform the trade',
	QUOTE_EXPIRED_TOKEN: 'The quote token has expired.',
	QUOTE_SUCCESS_REVIEW_TITLE: 'Quick Trade',
	QUOTE_SUCCESS_REVIEW_MESSAGE: 'You have successfully {0} {1} {2} for {3} {4}', // you have successfully buy 1 btc
	COUNTDOWN_ERROR_MESSAGE: 'Countdown is finished',
	WITHDRAW_PAGE: {
		BANK_TO_WITHDRAW: 'Bank to Withdraw to',
		MESSAGE_ABOUT_SEND: 'You are about to send',
		MESSAGE_BTC_WARNING:
			'Please ensure the accuracy of this address since {0} transfers are irreversible',
		MESSAGE_ABOUT_WITHDRAW: 'You are about to transfer to your bank account',
		MESSAGE_FEE: 'Transactions fee of {0} ({1}) included',
		MESSAGE_FEE_BASE: 'Transactions fee of {0} included',
		BASE_MESSAGE_1:
			'You can only withdraw to a bank account in a name that matches the name registered with your account.',
		BASE_MESSAGE_2: 'Withdrawal min amount',
		BASE_MESSAGE_3: 'Daily withdrawal max amount',
		BASE_INCREASE_LIMIT: 'Increase your daily limit',
		CONFIRM_VIA_EMAIL: 'Confirm via Email',
		CONFIRM_VIA_EMAIL_1: 'We have sent you a confirmation withdrawal email.',
		CONFIRM_VIA_EMAIL_2:
			'In order to complete the withdrawal process please confirm',
		CONFIRM_VIA_EMAIL_3: 'the withdrawal via your email within 5 minutes.',
		WITHDRAW_CONFIRM_SUCCESS_1:
			'Your withdrawal request is confirmed. It will be processed shortly.',
		WITHDRAW_CONFIRM_SUCCESS_2:
			'In order to view your withdrawal status please visit your withdrawal history page.',
		GO_WITHDRAWAL_HISTORY: 'Go To Withdrawal History',
	},
	WALLET_BUTTON_BASE_DEPOSIT: '入金',
	WALLET_BUTTON_BASE_WITHDRAW: '出金',
	WALLET_BUTTON_CRYPTOCURRENCY_DEPOSIT: '受取',
	WALLET_BUTTON_CRYPTOCURRENCY_WITHDRAW: '送金',
	AVAILABLE_TEXT: 'Available',
	AVAILABLE_BALANCE_TEXT: '使用可能な {0} 残高 : {1} {2}', // Available Bitcoin Balance: 2.6 BTC
	BALANCE_TEXT: '残高',
	CURRENCY_BALANCE_TEXT: '{0} Balance',
	WALLET_TABLE_AMOUNT_IN: `Amount in {0}`,
	WALLET_TABLE_TOTAL: '総額',
	WALLET_ALL_ASSETS: '総資産',
	HIDE_TEXT: 'Hide',
	PAGINATOR_FORMAT: '{0} / {1}',
	ORDERBOOK_SELLERS: '売却',
	ORDERBOOK_BUYERS: '購入',
	ORDERBOOK_SPREAD: 'スプレッド {0}', // 0 -> 660,000 T
	ORDERBOOK_SPREAD_PRICE: '{0} {1}', //// 0-> amount  1 -> symbol  600,000 T
	CALCULATE_MAX: '最大',
	DATEFIELD_TOOGLE_DATE_GR: 'Gregorian calendar',
	VERIFICATION_WARNING_TITLE: 'Verification you bank details',
	VERIFICATION_WARNING_MESSAGE:
		'Before you withdraw, you need to verify your bank details.',
	ORDER_SPENT: 'Spent',
	ORDER_RECEIVED: 'Received',
	ORDER_SOLD: 'Sold',
	ORDER_BOUGHT: 'Bought',
	ORDER_AVERAGE_PRICE: 'Average price',
	ORDER_TITLE_CREATED: 'Successfully created a limit {0}', // 0 -> buy / sell
	ORDER_TITLE_FULLY_FILLED: '{0} order successfully filled', // 0 -> buy / sell
	ORDER_TITLE_PARTIALLY_FILLED: '{0} order partially filled', // 0 -> buy / sell
	ORDER_TITLE_TRADE_COMPLETE: '{0} {1} order was successful', // 0 -> buy / sell
	LOGOUT_TITLE: 'ログアウトしました',
	LOGOUT_ERROR_TOKEN_EXPIRED: 'Token is expired',
	LOGOUT_ERROR_LOGIN_AGAIN: 'Login again', // ip doesnt match
	LOGOUT_ERROR_INVALID_TOKEN: '無効なトークン',
	LOGOUT_ERROR_INACTIVE:
		'You have been logged out because you have been inactive',
	ORDER_ENTRY_BUTTON: '{1} {0}', // 0 -> buy/sell 1 -> btc/..
	QUICK_TRADE_OUT_OF_LIMITS: 'Order size is out of the limits',
	QUICK_TRADE_TOKEN_USED: 'Token has been used',
	QUICK_TRADE_QUOTE_EXPIRED: 'Quote has expired',
	QUICK_TRADE_QUOTE_INVALID: 'Invalid quote',
	QUICK_TRADE_QUOTE_CALCULATING_ERROR: 'Error calculating the quote',
	QUICK_TRADE_ORDER_CAN_NOT_BE_FILLED:
		'The order with the current size can not be filled',
	QUICK_TRADE_ORDER_NOT_FILLED: 'Order is not filled',
	QUICK_TRADE_NO_BALANCE: 'Insufficient balance to perform the order',
	YES: 'Yes',
	NO: 'No',
	NEXT: 'Next',
	SKIP_FOR_NOW: 'Skip for now',
	SUBMIT: '提出',
	RESUBMIT: '再提出',
	VERIFICATION_NOTIFICATION_SKIP_TITLE: 'Missing Documents!',
	VERIFICATION_NOTIFICATION_SKIP_TEXT:
		'To get full access to withdrawal and deposit functions you must submit your identity documents in your account page.',
	VERIFICATION_NOTIFICATION_SUCCESS_TITLE: 'Success!',
	VERIFICATION_NOTIFICATION_SUCCESS_TEXT:
		'You will receive an email notification when your information has been processed. Processing can typically take 1-3 days.',
	VERIFICATION_NOTIFICATION_BUTTON: 'PROCEED TO EXCHANGE',
	ERROR_USER_ALREADY_VERIFIED: 'User already verified',
	ERROR_INVALID_CARD_USER: 'Bank or card information provided is incorrect',
	ERROR_INVALID_CARD_NUMBER: 'Invalid Card number',
	ERROR_LOGIN_USER_NOT_VERIFIED: 'User is not verified',
	ERROR_LOGIN_USER_NOT_ACTIVATED: 'User is not activated',
	ERROR_LOGIN_INVALID_CREDENTIALS: 'メールまたはパスワードが間違っています。',
	SMS_SENT_TO: 'SMS sent to {0}', // TODO check msg
	SMS_ERROR_SENT_TO:
		'{0}へのSMS送信中にエラーが発生しました。ページを更新してから再度お試しください。', // TODO check msg
	WITHDRAW_NOTIFICATION_TRANSACTION_ID: 'Transaction ID:', // TODO check msg
	CHECK_ORDER: 'Check and confirm your order',
	CHECK_ORDER_TYPE: '{0} {1}', // 0 -> maker/limit  1 -> sell/buy
	CONFIRM_TEXT: 'Confirm',
	GOTO_XHT_MARKET: 'Go to XHT market', // new
	INVALID_CAPTCHA: 'Invalid captcha',
	NO_FEE: 'N/A',
	SETTINGS_LANGUAGE_LABEL: '言語設定 (メールを含む)',
	SETTINGS_LANGUAGE_OPTIONS: LANGUAGES,
	SETTINGS_ORDERPOPUP_LABEL: 'Display order confirmation popup',
	SETTINGS_ORDERPOPUP_OPTIONS: [
		{ value: false, label: 'NO' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: true, label: 'YES' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SETTINGS_THEME_LABEL: 'テーマ設定', // TODO set right labels // ToDo
	SETTINGS_THEME_OPTIONS: [
		{ value: 'white', label: 'White' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: 'dark', label: 'Dark' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SETTING_BUTTON: '保存',
	STRING_WITH_PARENTHESIS: '{0} ({1})',
	VERIFICATION_NO_WITHDRAW_TITLE: '出金停止設定',
	VERIFICATION_NO_WITHDRAW_MESSAGE:
		'お客様のアカウントが出金停止に設定されました。',
	UP_TO_MARKET: 'Up to market',
	VIEW_MY_FEES: 'マイ手数料を見る', // new
	DEVELOPER_SECTION: {
		TITLE: 'APIキー',
		INFORMATION_TEXT:
			'APIは、ウォレットの残高情報、売買注文の管理、出金の要求、最近の取引、注文書、ティッカーなど市場データなどの機能を提供します。',
		ERROR_INACTIVE_OTP:
			'APIキーを生成するためには、2段階認証を設定する必要があります。',
		ENABLE_2FA: '2段階認証を設定',
		WARNING_TEXT: 'APIキーは他人と共有しないでください。',
		GENERATE_KEY: 'APIキーを生成',
		ACTIVE: '設定する',
		INACTIVE: '解除する',
		INVALID_LEVEL:
			'この機能を使用するためには、アカウントレベルのアップグレードが必要です。', // TODO
	},
	DEVELOPERS_TOKENS_POPUP: {
		GENERATE_TITLE: 'APIキーの生成',
		GENERATE_TEXT:
			'生成したAPIキーは再度確認することはできないので、安全な場所に保管してください。',
		GENERATE: '生成',
		DELETE_TITLE: 'APIキーの削除',
		DELETE_TEXT:
			'新しいAPIキーの生成はいつでも可能ですが、削除したAPIキーは元に戻せません。本当に削除しますか？',
		DELETE: 'APIキーを削除',
		FORM_NAME_LABEL: '名前',
		FORM_LABLE_PLACEHOLDER: 'Apiキー名',
		API_KEY_LABEL: 'APIキー',
		SECRET_KEY_LABEL: 'シークレットキー',
		CREATED_TITLE: 'APIキーをコピー',
		CREATED_TEXT_1:
			'APIキーは再度確認することができませんので、必ずコピーしておいてください。',
		CREATED_TEXT_2: '安全な場所に保管してください。',
	},
	DEVELOPERS_TOKENS_TABLE: {
		NAME: '名前',
		API_KEY: 'APIキー',
		SECRET: 'シークレットキー',
		CREATED: '生成日',
		REVOKE: '解除',
		REVOKED: '解除済み',
		REVOKE_TOOLTIP:
			'トークンを解除するためには、2段階認証を設定する必要があります。', // TODO
	},
	CHAT: {
		CHAT_TEXT: 'チャット',
		MARKET_CHAT: 'Market Chat',
		CHAT_UNREAD: '{0} ({1})', // 0 -> CHAT_TEXT, 1 -> number
		READ_MORE: 'さらに読み込む',
		SHOW_IMAGE: 'イメージ表示',
		HIDE_IMAGE: 'イメージ非表示',
		CHAT_MESSAGE_BOX_PLACEHOLDER: 'メッセージ',
		SIGN_UP_CHAT: 'ログインしてチャットする',
		JOIN_CHAT: 'チャットユーザー名の設定',
		TROLLBOX: 'Trollbox ({0})', // new
	},
	INVALID_USERNAME:
		'ユーザー名には3～15文字の半角英小文字、数字、_のみご利用可能です。',
	USERNAME_TAKEN:
		'このユーザー名は既に使用されています。別のユーザー名でお試しください。',
	USERNAME_LABEL: 'ユーザー名(チャット名として使用されます)',
	USERNAME_PLACEHOLDER: 'ユーザー名',
	TAB_USERNAME: 'ユーザー名',
	USERNAME_WARNING:
		'ユーザー名は1回のみ変更できます。ユーザー名が正しいか確認してください。',
	USERNAME_CANNOT_BE_CHANGED: 'ユーザー名を変更できません。',
	UPGRADE_LEVEL: 'アカウントレベルをアップグレード',
	LEVELS: {
		LABEL_LEVEL: 'レベル',
		LABEL_LEVEL_1: 'One',
		LABEL_LEVEL_2: 'Two',
		LABEL_LEVEL_3: 'Three',
		LABEL_MAKER_FEE: 'Maker Fee',
		LABEL_TAKER_FEE: 'Taker Fee',
		LABEL_BASE_DEPOSIT: '1日ユーロ―入金限度',
		LABEL_BASE_WITHDRAWAL: '1日ユーロ―出金限度',
		LABEL_BTC_DEPOSIT: '1日ビットコイン入金限度',
		LABEL_BTC_WITHDRAWAL: '1日ビットコイン出金限度',
		LABEL_ETH_DEPOSIT: '1日イーサリアム入金限度',
		LABEL_ETH_WITHDRAWAL: '1日イーサリアム出金限度',
		LABEL_PAIR_MAKER_FEE: '{0} Maker Fee',
		LABEL_PAIR_TAKER_FEE: '{0} Taker Fee',
		UNLIMITED: '無制限',
		BLOCKED: 'Disabled',
	},
	WALLET_ADDRESS_TITLE: '{0}ウォレット作成',
	WALLET_ADDRESS_GENERATE: '作成',
	WALLET_ADDRESS_MESSAGE:
		'ウォレットを作成すると入金および出金のアドレスが発行されます。',
	WALLET_ADDRESS_ERROR:
		'アドレスの発行中にエラーが発生しました。リフレッシュした後、再度お試しください。',
	DEPOSIT_WITHDRAW: '入金/出金',
	GENERATE_WALLET: 'ウォレット作成',
	TRADE_TAB_CHART: 'チャート',
	TRADE_TAB_TRADE: '取引',
	TRADE_TAB_ORDERS: '注文',
	TRADE_TAB_POSTS: 'Posts', // new
	WALLET_TAB_WALLET: 'ウォレット',
	WALLET_TAB_TRANSACTIONS: 'Transactions',
	RECEIVE_CURRENCY: '{0}受取',
	SEND_CURRENCY: '{0}送金',
	COPY_ADDRESS: 'アドレスをコピーする',
	SUCCESFUL_COPY: 'コピーされました！',
	QUICK_TRADE_MODE: 'クイック取引モード',
	JUST_NOW: 'just now',
	PAIR: 'ペア',
	ZERO_ASSET: '資産がありません。',
	DEPOSIT_ASSETS: '入金する',
	SEARCH_TXT: '検索',
	SEARCH_ASSETS: '資産検索',
	TOTAL_ASSETS_VALUE: '{0}の総額資産：{1}',
	SUMMARY: {
		TITLE: 'マイページ',
		TINY_PINK_SHRIMP_TRADER: 'Tiny Pink Shrimp Trader',
		TINY_PINK_SHRIMP_TRADER_ACCOUNT: 'Tiny Pink Shrimp Trader Account',
		LITTLE_RED_SNAPPER_TRADER: 'Little Red Snapper Trader',
		LITTLE_RED_SNAPPER_TRADER_ACCOUNT: 'Little Red Snapper Trader Account',
		CUNNING_BLUE_KRAKEN_TRADING: 'Cunning Blue Kraken Trading',
		CUNNING_BLUE_KRAKEN_TRADING_ACCOUNT: 'Cunning Blue Kraken Trading Account',
		BLACK_LEVIATHAN_TRADING: 'Black Leviathan Trading',
		BLACK_LEVIATHAN_TRADING_ACCOUNT: 'Black Leviathan Trading Account',
		URGENT_REQUIREMENTS: 'Urgent Requirements',
		TRADING_VOLUME: 'Trading Volume',
		ACCOUNT_ASSETS: 'アカウントの資産',
		ACCOUNT_DETAILS: 'Account Details',
		SHRIMP_ACCOUNT_TXT_1: 'Your journey begins here!',
		SHRIMP_ACCOUNT_TXT_2:
			'Keep swimming true, you’ll soon stand out from the rest of the shoal',
		SNAPPER_ACCOUNT_TXT_1:
			'Congrats on staying your course through the swell of the market.',
		SNAPPER_ACCOUNT_TXT_2:
			'Forge through and fight the surge for more crypto treasures ahead.',
		KRAKEN_ACCOUNT_TXT_1:
			'Likelier to crack jokes than hulls, this crustacean has weathered his share of storms!',
		LEVIATHAN_ACCOUNT_TXT_1:
			'Beast from the abyss, seeing through altcoins into unfathomable depths, masters of midnight waters and tidal wave.',
		VIEW_FEE_STRUCTURE: '手数料と限度額を見る',
		UPGRADE_ACCOUNT: 'アカウントアップグレード',
		ACTIVE_2FA_SECURITY: '2段階認証の設定',
		ACCOUNT_ASSETS_TXT_1: '保有中の資産がすべて表示されます。',
		ACCOUNT_ASSETS_TXT_2:
			'多くの資産を保有すると、より安い取引手数料と特別なバッジを含むアカウントにアップグレードできる資格が与えられます。',
		TRADING_VOLUME_TXT_1:
			'取引ボリュームの履歴は{0}で表示され、月末にすべての取引ペアから計算されます。',
		TRADING_VOLUME_TXT_2:
			'頻繁な取引活動によってアカウントをアップグレードでき、ユニークなバッジやその他の特典を獲得できます。',
		ACCOUNT_DETAILS_TXT_1:
			'アカウントの種類によって、アカウントバッジ、取引手数料、入出金の制限が決まります。',
		ACCOUNT_DETAILS_TXT_2:
			'アカウントの登録期間、活動水準、保有した総資産などでアカウントのアップグレードが決まります。',
		ACCOUNT_DETAILS_TXT_3:
			'レベルを維持するためには持続的な取引活動と一定金額以上の預金などの条件が必要です。',
		ACCOUNT_DETAILS_TXT_4:
			'各レベルに必要な取引活動および一定金額以上の預金が満たされない場合、レベルがダウングレードされることがあります。',
		REQUIREMENTS: '必要条件',
		ONE_REQUIREMENT: 'One Requirement only:', // new
		REQUEST_ACCOUNT_UPGRADE: 'アカウントのアップグレード申請',
		FEES_AND_LIMIT: '{0}の手数料および入出金限度額', // new
		FEES_AND_LIMIT_TXT_1:
			'仮想通貨のトレーダーになることは新しい始まりを意味します。リスクを負って多くの取引を賢く行うことによって、アカウントをアップグレードすることができます。',
		FEES_AND_LIMIT_TXT_2:
			'アカウントのレベルによって手数料や入出金限度額が異なります。より詳しい情報は{0}を参考してください。',
		DEPOSIT_WITHDRAWAL_ALLOWENCE: '入出金限度額',
		TRADING_FEE_STRUCTURE: '取引手数料',
		WITHDRAWAL: '出金',
		DEPOSIT: '入金',
		TAKER: 'テイカー',
		MAKER: 'メイカ－',
		WEBSITE: 'ウェブサイト',
		VIP_TRADER_ACCOUNT_ELIGIBLITY: 'VIPトレーダーのアップグレード条件',
		PRO_TRADER_ACCOUNT_ELIGIBLITY: 'Proトレーダーのアップグレード条件',
		TRADER_ACCOUNT_ELIGIBILITY: '{0}レベルのアップグレード条件',
		NOMINAL_TRADING: '名目取引',
		NOMINAL_TRADING_WITH_MONTH: '過去{0}の名目取引',
		ACCOUNT_AGE_OF_MONTHS: 'アカウント活動期間{0}ヶ月',
		TRADING_VOLUME_EQUIVALENT: '{0} {1}取引ボリューム等価',
		LEVEL_OF_ACCOUNT: 'アカウントレベル {0}',
		LEVEL_TXT_DEFAULT: 'ここにレベルの説明を追加してください。',
		LEVEL_1_TXT:
			'仮想通貨のトレーダーとしてのあなたの旅はここから始まります。ボーナスを取得するには、本人確認を完了し、取引手数料の低下と入出金限度額の上げられます。', // new
		LEVEL_2_TXT:
			'毎月3,000USDT以上の取引または、5,000XHT以上の残高を維持し、より低い取引手数料をお楽しみください。', // new
		LEVEL_3_TXT:
			'本人確認の認証を完了するとレベル3に到達できます。取引手数料の割引および入出金限度額の増加！プロトレーダーになる準備ができました。', // new
		LEVEL_4_TXT:
			'毎月10,000USDT以上の取引または、10,000XHT以上の残高を維持し、より低い取引手数料をお楽しみください。', // new
		LEVEL_5_TXT:
			'おめでとうございます！レベル５は取引所の管理者、Vaultユーザー、またはHollaExアフィリエイトプログラム(HAP)専用の特別なレベルです。高い入出金限度額と、無料のメイカ―手数料をお楽しみください。', // new
		LEVEL_6_TXT:
			'毎月300,000USDT以上の取引または、100,000XHT以上の残高を維持し、より低い取引手数料と増加された入出金限度額をお楽しみください。', // new
		LEVEL_7_TXT:
			'毎月500,000USDT以上の取引または、300,000XHT以上の残高を維持し、より低い取引手数料と増加された入出金限度額をお楽しみください。', // new
		LEVEL_8_TXT:
			'毎月600,000USDT以上の取引または、400,000XHT以上の残高を維持し、より低い取引手数料をお楽しみください。', // new
		LEVEL_9_TXT:
			'毎月2,000,000USDT以上の取引または、1,000,000XHT以上の残高を維持し、より低い取引手数料をお楽しみください。', // new
		LEVEL_10_TXT:
			'ホエールトレーダーアカウントはマーケットメーキングを通して利益を上げられるアカウントです。この特別なアカウントを取得するためにはお問い合わせください。', // new
		CURRENT_TXT: 'Current',
		TRADER_ACCOUNT_XHT_TEXT:
			'お客様のアカウントはXHTの先行販売期間にあります。つまり、XHTごとに0.10ドルでXHTを入手できます。 取引が決済されると、すべての預金はXHTに変換されます。',
		TRADER_ACCOUNT_TITLE: 'アカウント - 先行販売期間', // new
		HAP_ACCOUNT: 'HAPアカウント', // new
		HAP_ACCOUNT_TXT:
			'お客様のアカウントは認証済みのHollaEx登録プログラム(HAP)アカウントです。XHTの購入を希望する全員を招待して10％のボーナスを獲得できます。', // new
		EMAIL_VERIFICATION: 'メール認証', // new
		DOCUMENTS: 'ドキュメント', // new
		HAP_TEXT: 'HollaEx登録プログラム(HAP) {0}', // new
		LOCK_AN_EXCHANGE: '取引所ロック {0}', // new
		WALLET_SUBSCRIPTION_USERS: 'Vault登録利用者 {0}', // new
		TRADE_OVER_XHT: '{0} USDT以上の取引', // new
		TRADE_OVER_BTC: '{0} BTC以上の取引', // new
		XHT_IN_WALLET: '{0} XHTの残高', // new
		REWARDS_BONUS: 'リワードとボーナス', // new
		COMPLETE_TASK_DESC:
			'タスクを完了し、10,000ドル以上のボーナスを獲得してください。', // new
		TASKS: 'タスク', // new
		MAKE_FIRST_DEPOSIT: '初めての入金で、1XHTを受け取れます。', // new
		BUY_FIRST_XHT: 'XHTを初購入すると、5XHTのボーナスを受け取れます。', // new
		COMPLETE_ACC_VERIFICATION:
			'アカウントの認証を完了して、20XHTのボーナスを受け取れます。', // new
		INVITE_USER: '招待した友達の取引から発生する報酬を受け取れます。', // new
		JOIN_HAP:
			'HAPに参加して、販売するHollaExキットごとに10％の報酬を受け取れます。', // new
		EARN_RUNNING_EXCHANGE:
			'自分の取引所を実行してパッシブ・インカムを受け取れます。', // new
		XHT_WAVE_AUCTION: 'XHTウェーブオークションデータ', // new
		XHT_WAVE_DESC_1:
			'HollaExトークン(XHT)の配布は、ウェーブオークションを通じて行われます。', // new
		XHT_WAVE_DESC_2:
			'ウェーブオークションは、ランダムな量のXHTをランダムな時間に最高入札者に販売されます。', // new
		XHT_WAVE_DESC_3:
			'以下から、ウェーブオークションの履歴データを確認できます。', // new
		WAVE_AUCTION_PHASE: 'ウェーブオークションフェーズ {0}', // new
		LEARN_MORE_WAVE_AUCTION: 'ウェーブオークションの詳細', // new
		WAVE_NUMBER: 'ウェーブナンバー', // new
		DISCOUNT: '( {0}%割引 )', // new
		MY_FEES_LIMITS: '手数料と限度額', // new
		VIEW_MORE_MARKETS: 'もっと見る', // new
	},
	REFERRAL_LINK: {
		TITLE: 'お友達招待', // new
		INFO_TEXT:
			'リンクをシェアして友達に紹介できます。このリンクを通して登録すると、{0}%が割引されます。',
		COPY_FIELD_LABEL:
			'以下のリンクを友達と共有してコミッションを獲得できます：', // new
		REFERRED_USER_COUT: '{0}ユーザーを招待しました', // new
		COPY_LINK_BUTTON: '招待リンクをコピーする', // new
		XHT_TITLE: '招待履歴', // new
		XHT_INFO_TEXT: '友達を招待してコミッションを獲得しましょう。', // new
		XHT_INFO_TEXT_1: 'コミッションは定期的にウォレットに支払われます。', // new
		APPLICATION_TXT:
			'HollaEx Kitのディストリビューターになるには、申請書に記入してください。', // new
		TOTAL_REFERRAL: '招待した人の購入合計:', // new
		PENDING_REFERRAL: '保留中のコミッション：', // new
		EARN_REFERRAL: '獲得したコミッション：', // new
		XHT_COUNT: '{0}XHT', // new
		APPLY_BUTTON: '適用', // new
	},
	STAKE_TOKEN: {
		TITLE: 'HollaExトークンのステーキング', // new
		INFO_TXT1:
			'HollaEx Kitの取引所ソフトウェアを実行するためにはHollaExトークン(XHT)が担保として必要です。', // new
		INFO_TXT2:
			'同じ方法でHollaExトークンを担保し、ウェーブオークション中に販売されなかったXHTを獲得できます。', // new
		INFO_TXT3:
			'dash.bitholla.comにアクセスして、今すぐ自分の取引所を実行し、それを担保に無料のXHTを獲得してください。', // new
		BUTTON_TXT: '詳細を見る', // new
	},
	TERMS_OF_SERVICES: {
		// new
		TITLE: 'HollaExトークン購入規約',
		SERVICE_AGREEMENT: AGREEMENT,
		PROCEED: '続行',
		AGREE_TERMS_LABEL: 'HollaExトークンの購入規約を読み、同意します。',
		RISK_INVOLVED_LABEL: 'リスクについて理解しました。',
		DOWNLOAD_PDF: 'PDFをダウンロードする',
		DEPOSIT_FUNDS:
			'HollaExトークン(XHT)を取得するには、ウォレットに資金を入金してください。',
		READ_FAG: 'HollaExのFAQを読む：{0}',
		READ_DOCUMENTATION: 'HollaExの白書を読む：{0}',
		READ_WAVES: 'パブリックウェーブオークションの規約を読む {0}', // new
		DOWNLOAD_BUY_XHT:
			'PDFをダウンロードして、{0}の段階別プロセスを確認できます。',
		HOW_TO_BUY: 'HollaExトークン(XHT)の購入方法 ',
		PUBLIC_SALES: 'パブリックウェーブオークション', // new
		CONTACT_US:
			'何かご不明な点がございましたら、いつでもお気軽に{0}までお問い合わせください。',
		VISUAL_STEP: '{0}の段階別プロセスを確認する。', // new
		WARNING_TXT:
			'お客様のリクエストを確認し、HollaEx取引所へのアクセス方法に関する詳細な手順をメールで送信いたします。', // new
		WARNING_TXT1:
			'それまでの間に、以下のリソースを使用してHollaExのネットワークを体験できます。', // new
		XHT_ORDER_TXT_1: '取引を始めるにはログインしてください。', // new
		XHT_ORDER_TXT_2: '', // new
		XHT_ORDER_TXT_3: '{0}または、{1}', // new
		XHT_TITLE: 'XHT', //new
		XHT_TRADE_TXT_1: '取引履歴を表示するにはログインしてください。', //new
		XHT_TRADE_TXT_2: '{0}して、取引履歴を表示できます。', //new
		LOGIN_HERE: 'ログインする',
	},
	WAVES: {
		// new
		TITLE: 'Wave Info',
		NEXT_WAVE: 'Next Wave',
		WAVE_AMOUNT: 'Amount in Wave',
		FLOOR: 'Floor',
		LAST_WAVE: 'Last wave',
	},
	TYPES_OF_POSTS: {
		// new
		TITLE: 'POSTS',
		ANNOUNCEMEN: 'Announcement',
		SYSTEM_UPDATE: 'System Update',
		LAST_WAVE: 'Last Wave',
		ANNOUNCEMENT_TXT: 'Free XHT will be distributed to all wallets that apply',
		SYSTEM_UPDATE_TIME: 'Time: 12:31 PM, December 19th, 2019	',
		SYSTEM_UPDATE_DURATION: '1 hour',
		LAST_WAVE_AMOUNT: '100, 213 XHT',
		LAST_WAVE_REDISTRIBUTED: ' 11, 211',
		LAST_WAVE_TIME: ' 12: 31 PM, December 19th, 2019',
	},
	USER_LEVEL: 'ユーザーレベル', // new
	LIMIT_AMOUNT: '限度額', // new
	FEE_AMOUNT: '手数料', // new
	COINS: 'コイン', // new
	PAIRS: 'ペア', // new
	NOTE_FOR_EDIT_COIN:
		'参考事項：{0}の追加および削除には{1}を参照してください。', // new
	REFER_DOCS_LINK: 'ドキュメント', // new
	RESTART_TO_APPLY:
		'変更事項を適用するために取引所を再起動する必要があります。', // new
	TRIAL_EXCHANGE_MSG:
		'お客様は{0}のテストバージョンをご利用中です。これは、{1}日後に終了します。', // new
	EXPIRY_EXCHANGE_MSG:
		'お客様の取引所の有効期限が終了しました。活性化のためにdash.bitholla.comに移動してください。', // new
	EXPIRED_INFO_1: 'お客様のトライアル期間が終了しました。', // new
	EXPIRED_INFO_2: '取引所を活性化するためには担保が必要です。', // new
	EXPIRED_BUTTON_TXT: '取引所を活性化する', // new
	TRADE_POSTS: {
		// new
		ANNOUNCEMENT: 'お知らせ',
		ANNOUNCEMNT_TXT_3:
			'HollaExとウェーブオークションの公開は2020年1月1日に再スケジュールされます。ウォレットの入出金は現在もご利用できます。',
		ANNOUNCEMNT_TXT_4:
			'明けましておめでとうございます。 私たちは2020年からローンチされる最も開放的な取引プラットフォームのオープンで様々な活動をお願い致します。',
		ANNOUNCEMNT_TXT_1:
			'友達に取引所を紹介して、HAPプログラムと共にXHTを獲得しましょう。 {0}。',
		DEFAULT_ANNOUNCEMENT: 'このセクションには、取引所の公示が表示されます！',
		ANNOUNCEMENT_TXT_2: '無料のXHTは、{0}のすべてのウォレットに配布されます。',
		LEARN_MORE: 'さらに詳しく',
		APPLY_TODAY: '今すぐ登録', // new
	},
	OPEN_WALLET: 'Open wallet', // new
	AGO: 'ago', // new
	LIMITS_BLOCK: {
		HEADER_ROW_DESCRIPTION:
			'すべての資産に対する24時間の入出金限度額（アカウントレベル {0})',
		HEADER_ROW_AMOUNT: '24時間数量 ({0})',
	},
	MARKETS_TABLE: {
		VIEW_MARKETS: 'もっと見る', //new
	},
	MARKET_OPTIONS: [
		{ value: 'List', label: 'リスト' }, // new
		{ value: 'Card', label: 'カード' }, // new
	],
	ALL: 'すべて', //new
	ASSET_TXT: '資産', //new
	ONE_DAY: '1 日', //new
	ONE_WEEK: '1 週間', //new
	MONTH: '{0} ヵ月', //new
	START_DATE: '開始日', //new
	END_DATE: '終了日', //new
	WITHDRAWALS_FORM_NETWORK_WARNING:
		'選択したネットワークが入金先のウォレットネットワークと互換性があるかを確認してください。', //new
	WITHDRAWALS_FORM_NETWORK_LABEL: 'ネットワーク', //new
	CUMULATIVE_AMOUNT_SYMBOL: 'トータル', //new
	ORDER_MODE: '注文モード', //new
	REGULAR: '一般', //new
	STOPS: 'ストップ', //new
	CLEAR: 'クリア', //new
	POST_ONLY: 'ポストオンリー', //new
	POST_ONLY_TOOLTIP: 'ポストオンリー注文は指値', //new
	ORDER_ENTRY_ADVANCED: 'アドバンス', //new
	ESTIMATED_PRICE: '推定価格', //new
	VIEW_ALL: 'すべてを見る', //new
	TRIGGER_PRICE: 'トリガー価格', //new
};
